@if (!loading) {
<div class="card">
  <div class="card-header">
    <span>{{ taskTypeName }} - Feedback</span>
    <button (click)="close()" type="button" class="btn-close float-end"></button>
  </div>
  <div class="card-body">
    <div class="card mb-5">
      <div class="card-header">Feedback Summary</div>
      <div class="card-body d-flex gap-0 p-0 overflow-hidden">
        <dl class="summary-meta mb-0 bg-light px-3 py-2">
          <dt class="fw-bold">Task ID</dt>
          <dd class="mb-0">{{ taskFeedback.TaskId }}</dd>
          <dt class="fw-bold">Review Date</dt>
          <dd class="mb-0">{{ taskFeedback.ReviewDate | dateText: 'M/DD/YYYY h:mm a' }}</dd>
          <dt class="fw-bold">Task Type</dt>
          <dd class="mb-0">{{ taskTypeName }}</dd>
          <dt class="fw-bold">Source</dt>
          <dd class="mb-0">{{ feedbackSource }}</dd>
          <dt class="fw-bold">Status</dt>
          <dd class="mb-0" [class.text-success]="taskFeedback.Passed" [class.text-danger]="!taskFeedback.Passed">{{ taskFeedback.Passed ? 'Approved' : 'Rejected' }}{{ totalAdditions || totalRemovals ? ' - Revised' : '' }}</dd>
          <dt class="fw-bold">Revisions</dt>
          <dd class="mb-0 d-flex gap-2">
            @if (!totalAdditions && !totalRemovals) {
              <span class="text-muted">No Changes</span>
            } @else {
              @if (totalRemovals) {
                <span class="text-danger">{{ totalRemovals }} removal{{ totalRemovals === 1 ? '' : 's' }}</span>
              }
              @if (totalAdditions) {
                <span class="text-success">{{ totalAdditions }} addition{{ totalAdditions === 1 ? '' : 's' }}</span>
              }
            }
          </dd>
        </dl>
        <div class="flex-fill border-start px-3 py-2">
          <div class="fw-bold mb-1">{{ feedbackSource }} Feedback</div>
          <div [innerHTML]="taskFeedback.FeedbackText || 'No feedback provided.'"></div>
        </div>
      </div>
    </div>
    @if (taskFeedback.OriginalPageOptimizationAudit || taskFeedback.ModifiedPageOptimizationAudit) {
    <shared-components-content-comparison
      class="mt-3"
      [modifiedLabel]="feedbackSource"
      heading="Audit"
      [originalContent]="generateAuditSummary(taskFeedback.OriginalPageOptimizationAudit)"
      [modifiedContent]="generateAuditSummary(taskFeedback.ModifiedPageOptimizationAudit)"
      (diffComputed)="onDiffComputed('Audit', $event)">
    </shared-components-content-comparison>
    }
    @if (taskFeedback.OriginalPageOptimization || taskFeedback.ModifiedPageOptimization) {
    <div class="d-flex flex-column gap-2">
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="Title Tag"
        [originalContent]="taskFeedback.OriginalPageOptimization?.titleTag"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.titleTag"
        (diffComputed)="onDiffComputed('Title Tag', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="Meta Description"
        [originalContent]="taskFeedback.OriginalPageOptimization?.metaDescription"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.metaDescription"
        (diffComputed)="onDiffComputed('Meta Description', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="Alt Image Tags"
        [originalContent]="taskFeedback.OriginalPageOptimization?.altImageTags"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.altImageTags"
        (diffComputed)="onDiffComputed('Alt Image Tags', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="Additional Keywords"
        [originalContent]="formatKeywords(taskFeedback.OriginalPageOptimization?.additionalKeywords)"
        [modifiedContent]="formatKeywords(taskFeedback.ModifiedPageOptimization?.additionalKeywords)"
        (diffComputed)="onDiffComputed('Additional Keywords', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        [preformatted]="true"
        heading="Schema Markup"
        [originalContent]="taskFeedback.OriginalPageOptimization?.schemaMarkup"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.schemaMarkup"
        (diffComputed)="onDiffComputed('Schema Markup', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="Implementation Instructions"
        [originalContent]="taskFeedback.OriginalPageOptimization?.implementationInstructions"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.implementationInstructions"
        (diffComputed)="onDiffComputed('Implementation Instructions', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="Body Copy"
        [originalContent]="taskFeedback.OriginalPageOptimization?.bodyCopy"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.bodyCopy"
        (diffComputed)="onDiffComputed('Body Copy', $event)">
      </shared-components-content-comparison>
      <shared-components-content-comparison
        [modifiedLabel]="feedbackSource"
        heading="FAQ Copy"
        [originalContent]="taskFeedback.OriginalPageOptimization?.faqCopy"
        [modifiedContent]="taskFeedback.ModifiedPageOptimization?.faqCopy"
        (diffComputed)="onDiffComputed('FAQ Copy', $event)">
      </shared-components-content-comparison>
    </div>
    }
  </div>
  <div class="card-footer text-end">
    <button (click)="close()" class="btn btn-link">Close</button>
  </div>
</div>
}
